import { cva, VariantProps } from "class-variance-authority";

export const formControlVariants = cva(
  [
    "border-outline",
    "outline-none border-0 disabled:bg-gray-100 placeholder-gray-400 somerandoclass",
    "ring-w-form-base enabled:hover:ring-w-form-hover focus:ring-w-form-focus",
    "data-[focus-within=true]:ring-w-form-focus",
    "data-[hovered=true]:ring-w-form-hover",
  ],
  {
    variants: {
      vColor: {
        pristine: [
          "focus:ring-color-form-outline enabled:hover:ring-color-form-outline",
        ],
        dirty: [
          "ring-color-form-dirty focus:ring-color-form-diry enabled:hover:ring-color-form-diry",
        ],
        error: [
          "ring-color-form-error focus:ring-color-form-error enabled:hover:ring-color-form-error",
        ],
      },
      vSize: {
        sm: ["min-h-form-sm py-1 px-2 text-sm rounded-form-sm"], //31px
        md: ["min-h-form-md py-1 px-3 text-base rounded-form-md"], //38px
        lg: "min-h-form-lg py-1 px-4 text-lg rounded-form-lg", //48px
      },
    },
    defaultVariants: {
      vColor: "pristine",
      vSize: "md",
    },
  },
);

export type FormControlVariantsProps = VariantProps<typeof formControlVariants>;

export const formControlSizes = cva(
  [
    // common
    //outline
  ],
  {
    variants: {
      size: {
        sm: ["h-form-sm py-1 px-2 text-sm rounded-form-sm"], //31px
        md: ["h-form-md py-1 px-3 text-base rounded-form-md"], //38px
        lg: "h-form-lg py-1 px-4 text-lg rounded-form-lg", //48px
        unset: "",
      },
    },
    defaultVariants: { size: "md" },
  },
);

export const formTextSizes = cva([], {
  variants: {
    vSize: {
      sm: ["text-sm"],
      md: ["text-base"],
      lg: ["text-lg"],
    },
  },
  defaultVariants: { vSize: "md" },
});
